import { consultarSimple } from "./crud";

// Correos de encomiendas y visitantes al residente: mismos endpoints y mismos campos que la app
// (coordiph/lib/function/backend.dart → enviarCorreoEncomienda, enviarCorreoEntregaEncomienda,
// enviarCorreoVisitante). Si el envío falla no se detiene el registro, igual que en la app.

const URL_BACKEND = "https://coordiph.herokuapp.com";

const enviar = async (ruta, datos) => {
  try {
    const resp = await fetch(`${URL_BACKEND}${ruta}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(datos),
    });
    return resp.ok;
  } catch (error) {
    console.error(`Error enviando correo (${ruta}):`, error);
    return false;
  }
};

const conjunto = () => ({
  cliente: localStorage.getItem("RazonSocial") || "",
  codigoCliente: localStorage.getItem("CodigoCliente") || "",
});

const esCorreoValido = (valor) =>
  typeof valor === "string" && valor !== "" && valor !== "null";

// Correo registrado para la vivienda: notificaciones/{nit}/{vivienda en minúscula y sin espacios}.
export const correoDeVivienda = async (nit, vivienda) => {
  const clave = (vivienda || "").toString().toLowerCase().replaceAll(" ", "");
  if (!nit || !clave) return null;
  const valor = await consultarSimple(`notificaciones/${nit}/${clave}`);
  return esCorreoValido(valor) ? valor : null;
};

// Igual que crear_encomienda.dart: notificaciones_excluidas/{correo sin espacios, @ ni puntos}.
export const correoExcluido = async (correo) => {
  const clave = (correo || "").toString().toLowerCase()
    .replaceAll(" ", "").replaceAll("@", "").replaceAll(".", "");
  if (!clave) return false;
  const valor = await consultarSimple(`notificaciones_excluidas/${clave}`);
  return valor !== null && typeof valor !== "object" && `${valor}` !== "" && `${valor}` !== "null";
};

// Paquete recibido en portería.
export const enviarCorreoEncomienda = ({ correo, urlFoto, quienLoTrae, contenido, direccion }) =>
  enviar("/encomiendas/enviarcorreo", {
    correoElectronico: correo,
    urlFoto: urlFoto ?? "",
    quienLoTrae,
    contenido,
    direccion,
    ...conjunto(),
  });

// Paquete entregado al residente.
export const enviarCorreoEntregaEncomienda = ({
  correo, urlFoto, urlFirma, quienLoTrae, nombreRecibe, contenido, direccion, fechaEntrega,
}) =>
  enviar("/encomiendas/enviarcorreoentrega", {
    correoElectronico: correo,
    urlFoto: urlFoto ?? "",
    urlFirma: urlFirma ?? "",
    quienLoTrae,
    nombreRecibe,
    contenido,
    direccion,
    fechaEntrega,
    ...conjunto(),
  });

// Ingreso o salida de un visitante.
export const enviarCorreoVisitante = ({
  correo, nombreVisitante, tipoDocumento, numeroDocumento, direccion, tipoVisitante, autorizo, estado, fechaHora,
}) =>
  enviar("/visitantes/enviarcorreo", {
    correoElectronico: correo,
    nombreVisitante,
    tipoDocumento,
    numeroDocumento,
    direccion,
    tipoVisitante,
    autorizo,
    estado,
    fechaHora,
    ...conjunto(),
  });

const escapar = (texto) => `${texto ?? ""}`
  .replaceAll("&", "&amp;").replaceAll("<", "&lt;").replaceAll(">", "&gt;").replaceAll('"', "&quot;");

// Línea que se muestra al terminar, como el aviso "Notificación enviada al correo: …" de la app.
// Siempre dice qué pasó con el correo, para que portería sepa si el residente quedó avisado.
export const mensajeNotificacion = ({ correo, excluido = false, enviado = false }) => {
  let icono = "bi-envelope-check";
  let color = "#15803d";
  let texto;
  if (!correo) {
    icono = "bi-envelope-x";
    color = "#b45309";
    texto = "La vivienda no tiene un correo registrado. No se envió notificación por correo.";
  } else if (excluido) {
    icono = "bi-envelope-x";
    color = "#b45309";
    texto = `El correo <strong>${escapar(correo)}</strong> pidió no recibir notificaciones.`;
  } else if (enviado) {
    texto = `Notificación enviada al correo:<br><strong>${escapar(correo)}</strong>`;
  } else {
    icono = "bi-envelope-exclamation";
    color = "#b91c1c";
    texto = `No se pudo enviar la notificación al correo:<br><strong>${escapar(correo)}</strong>`;
  }
  return `<div style="margin-top:14px;padding:12px 14px;border-radius:10px;background:#f8fafc;` +
    `border:1px solid #e2e8f0;color:${color};font-size:17px;line-height:1.4;">` +
    `<i class="bi ${icono}" style="font-size:22px;vertical-align:middle;margin-right:6px;"></i>${texto}</div>`;
};
